'use strict';

var React = require('react');

var SvgLegalMajor = function SvgLegalMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.75a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.5 5.75a2 2 0 0 1 2-2h8.5a2 2 0 0 1 2 2v7.5h2a.75.75 0 0 1 .75.75v1.5a2.25 2.25 0 0 1-2.25 2.25h-7.75a2.75 2.75 0 0 1-2.75-2.75v-4.75h-1.75a.75.75 0 0 1-.75-.75v-3.75Zm5.25 10.5c.69 0 1.25-.56 1.25-1.25v-1a.75.75 0 0 1 .75-.75h3.75v-7.5a.5.5 0 0 0-.5-.5h-6.563a1.982 1.982 0 0 1 .063.5v9.25c0 .69.56 1.25 1.25 1.25Zm2.75-1.5v.25c0 .45-.108.875-.3 1.25h5.3a.75.75 0 0 0 .75-.75v-.75h-5.75Zm-6.5-9a.5.5 0 0 1 .498-.5h.002a.5.5 0 0 1 .5.5v3h-1v-3Z"
  }));
};
SvgLegalMajor.displayName = "LegalMajor";

exports.SvgLegalMajor = SvgLegalMajor;
